export const scrollOnce = (
    ref: React.RefObject<HTMLElement>,
    direction: "left" | "right",
    amount = 200
  ) => {
    const scrollAmount = direction === "left" ? -amount : amount;
    if (ref.current) {
      ref.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };
  
  export const startContinuousScroll = (
    ref: React.RefObject<HTMLElement>,
    direction: "left" | "right",
    intervalRef: React.MutableRefObject<NodeJS.Timeout | null>,
    amount = 200,
    speed = 200
  ) => {
    const scrollAmount = direction === "left" ? -amount : amount;
  
    intervalRef.current = setInterval(() => {
      if (ref.current) {
        ref.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }, speed);
  };
  
  export const stopContinuousScroll = (
    intervalRef: React.MutableRefObject<NodeJS.Timeout | null>
  ) => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  